/** Безопасный lookup определения экземпляра без non-null assertions в коде карт/flow. */
export function cardDefinitionOf(state, registry, instanceId) {
    const instance = state.instances[instanceId];
    return instance === undefined ? undefined : registry.get(instance.defId);
}
export function cardTypeOf(state, registry, instanceId) {
    return cardDefinitionOf(state, registry, instanceId)?.type;
}
/** Единственный D41-путь динамической стоимости для validate и committed-оплаты. */
export function effectiveCardCost(state, registry, instanceId) {
    const definition = cardDefinitionOf(state, registry, instanceId);
    if (definition === undefined)
        return undefined;
    const base = definition.cost ?? 0;
    const calculated = definition.effectiveCost?.(state, instanceId, base) ?? base;
    if (!Number.isFinite(calculated) || !Number.isInteger(calculated)) {
        throw new Error(`effectiveCardCost: карта "${definition.id}" вернула нецелую стоимость ${String(calculated)}`);
    }
    return Math.max(0, definition.minimumCost ?? 0, calculated);
}
/** Доступная plan-энергия: временная часть действует только в назначенном раунде. */
export function availableEnergy(state, player) {
    const temporary = player.resources.temporaryEnergyRound === state.round
        ? player.resources.temporaryEnergy
        : 0;
    return player.resources.energy + temporary;
}
//# sourceMappingURL=query.js.map